import { Fragment, h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { Banniere } from '../../components/banniere/banniere.jsx'
import Glide from '@glidejs/glide'
import style from './shadowStyles_carrousel.scss'

export const carrouselStyle = style

export const carrouselPlaceholder = `
   #carrousel.placeholder {
      min-height: 355px;
      @media (max-width: 960px) {
         min-height: 423px;
      }
      @media (max-width: 479px) {
         min-height: calc((100vw * (520 / 480)) + 30px);
      }
   }
`

export const Carrousel = ({ format, slides, marginBottom = '', elementId }) => {
   useLayoutEffect(() => {
      let targetNode = document.querySelector(`#${elementId}`)
      glideInit(slides.length, targetNode)

      //Affichage mention légales
      let showButton = document.querySelectorAll('.showButton')
      showButton.forEach((el) => {
         el.addEventListener('keydown', function (event) {
            const keyD = event.key !== undefined ? event.key : event.code
            if (keyD === 'Enter' || keyD === 13 || ['Spacebar', ' '].indexOf(keyD) >= 0 || keyD === 32) {
               event.preventDefault()
               this.click()
            }
         })
      })
   }, [])

   return (
      <section class="row no-gutters">
         <div class="col-12">
            <h2 class="sr-only">L'actualité des offres, produits et services</h2>
            <div id="zone_top_carrousel" data-testid={`${format === '1200x388-960x1040' ? 'carrousel' : 'bande-carrousel'}`} class={`glide glide-carousel ${marginBottom}`}>
               <div class="glide__track" data-glide-el="track">
                  <div class="glide__slides">
                     {slides.map((slide, index) => {
                        return (
                           <div class="glide__slide" data-slidenb={index}>
                              <Banniere {...slide} format={format} index={index} /> {/* l'index permet un ID unique pour l'accessibilité dans les bannières */}
                           </div>
                        )
                     })}
                  </div>
               </div>

               {slides.length > 1 ? <Navigation slides={slides} /> : null}
            </div>
         </div>
      </section>
   )
}

const Navigation = ({ slides }) => {
   return (
      <Fragment>
         <div class="glide__arrows">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<" aria-label="précédent" tabindex="-1">
               <span></span>
            </button>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">" aria-label="suivant" tabindex="-1">
               <span></span>
            </button>
         </div>

         <div class="glide__bullets" data-glide-el="controls[nav]">
            {slides.map((slide, index) => {
               return (
                  <div class="glide__bullet" data-glide-dir={`=${index}`} aria-hidden="true">
                     <span></span>
                  </div>
               )
            })}
         </div>

         <button type="button" class="glide__playpause glide__playpause--pause" aria-label="Mettre en pause le carrousel"></button>
      </Fragment>
   )
}

const glideInit = (nbSlide, carrouselTarget) => {
   carrouselTarget = carrouselTarget.shadowRoot || carrouselTarget //s'il y a un shadow root, on l'utilise
   const autoplaySeconds = 5000
   var autoplayValue = autoplaySeconds
   var dragThresholdValue = true
   var swipeThresholdValue = true

   if (nbSlide === 1) {
      autoplayValue = false
      dragThresholdValue = false
      swipeThresholdValue = false
   }

   let glideOption = {
      type: 'carousel',
      gap: 0,
      autoplay: autoplayValue,
      hoverpause: false, // géré de notre côté
      dragThreshold: dragThresholdValue,
      swipeThreshold: swipeThresholdValue,
      keyboard: false,
   }
   const shadowCarrousel = carrouselTarget.querySelector('.glide-carousel')
   let glideCarrousel = new Glide(shadowCarrousel, glideOption)
   glideCarrousel.mount()

   // MENTIONS LEGALES
   // Referme les mentions legals si le slide n'est plus actif
   const observer = new MutationObserver((mutationList, observer) => {
      mutationList.forEach((mutation) => {
         if (mutation.target.classList.value === 'glide__slide glide__slide--active') {
            carrouselTarget.querySelectorAll('.glide-carousel .glide__slide:not(.glide__slide--active) .openContent').forEach((el) => {
               el.classList.remove('openContent')
            })
         }
      })
   })
   const parentNode = carrouselTarget.querySelector('.glide-carousel .glide__slides')
   observer.observe(parentNode, { attributes: true, childList: false, subtree: true })

   // NAVIGATION FLECHES
   // ajout d'evenements pour la navigation flèche
   // fix bug double event sur touch device : https://github.com/glidejs/glide/issues/417
   const glideArrows = carrouselTarget.querySelectorAll('.glide-carousel .glide__arrow')
   glideArrows.forEach(function (glideArrow) {
      glideArrow.addEventListener('click', function () {
         glideCarrousel.go(glideArrow.dataset.glideDir)
      })
   })

   // BOUTON PAUSE
   var glideForcePause = false

   carrouselTarget.querySelectorAll('.glide__playpause').forEach((el) => {
      const ariaLabelPlay = 'Reprendre la lecture du carrousel'
      const ariaLabelPause = 'Mettre en pause le carrousel'

      // init
      if (glideForcePause) {
         el.classList.remove('glide__playpause--pause')
         el.classList.add('glide__playpause--play')
         el.setAttribute('aria-label', ariaLabelPlay)
      }
      // click event
      el.addEventListener('click', (e) => {
         if (!glideForcePause) {
            glideCarrousel.update({ autoplay: false })
            autoplayValue = false
            tabEventsInit()
            pauseOnHoverInit()
            el.classList.remove('glide__playpause--pause')
            el.classList.add('glide__playpause--play')
            el.setAttribute('aria-label', ariaLabelPlay)
            glideForcePause = true
         } else {
            glideCarrousel.update({ autoplay: autoplayValue })
            autoplayValue = autoplaySeconds
            tabEventsInit()
            pauseOnHoverInit()
            el.classList.remove('glide__playpause--play')
            el.classList.add('glide__playpause--pause')
            el.setAttribute('aria-label', ariaLabelPause)
            glideForcePause = false
         }
      })

      el.addEventListener('mousedown', (e) => {
         e.preventDefault()
      })
   })

   // INTERACTIONS SOURIS
   // remove focus au clic souris
   carrouselTarget.querySelectorAll('.glide-carousel a.banniere').forEach((el) => {
      el.addEventListener('mousedown', (event) => {
         event.preventDefault()
      })
   })
   // pause au survol
   const pauseOnHoverInit = () => {
      carrouselTarget.querySelectorAll('.glide-carousel').forEach((el) => {
         el.addEventListener('mouseenter', (e) => {
            glideCarrousel.update({ autoplay: false })
         })

         el.addEventListener('mouseleave', (e) => {
            if (!glideForcePause) {
               glideCarrousel.update({ autoplay: autoplayValue })
            }
         })
      })
   }
   pauseOnHoverInit()

   // NAVIGATION CLAVIER
   // ignore clones (<a> de la slide + <button> des conditions legales)
   const removeTabIndexFromClones = () => {
      carrouselTarget.querySelectorAll('.glide-carousel .glide__slide--clone .banniere').forEach((el) => {
         el.setAttribute('tabindex', '-1')
      })
      carrouselTarget.querySelectorAll('.glide-carousel .glide__slide--clone .showButton').forEach((el) => {
         el.setAttribute('tabindex', '-1')
      })
   }
   removeTabIndexFromClones()

   carrouselTarget.querySelectorAll('.glide-carousel').forEach((el) => {
      el.addEventListener('focusin', (e) => {
         removeTabIndexFromClones()
      })
      el.addEventListener('focusout', (e) => {
         removeTabIndexFromClones()
      })
   })

   const setTabEventsInitListeners = (el) => {
      let currentSlide = el.closest('[data-slidenb]').dataset.slidenb
      let showButtonIsHover = false

      el.addEventListener('mouseover', (e) => {
         showButtonIsHover = true
      })

      el.addEventListener('focus', (e) => {
         if (!showButtonIsHover) {
            // evite le déclencherment au focus souris
            // stop autoplay
            glideCarrousel.update({ autoplay: false })
            // prevent default tab scroll
            el.closest('.glide__track').scrollLeft = 0
            // go to focused slide
            glideCarrousel.go('=' + currentSlide)
         }
      })

      el.addEventListener('blur', () => {
         if (!el.dataset.glidePaused && !glideForcePause) {
            // start autoplay
            glideCarrousel.update({ autoplay: autoplayValue })
         }
      })
   }
   // init nav clavier
   const tabEventsInit = () => {
      carrouselTarget.querySelectorAll('.glide-carousel .glide__slide:not(.glide__slide--clone) .banniere').forEach((el) => {
         setTabEventsInitListeners(el)
      })
      carrouselTarget.querySelectorAll('.glide-carousel .glide__slide:not(.glide__slide--clone) .showButton').forEach((el) => {
         setTabEventsInitListeners(el)
      })
   }
   tabEventsInit()
}
